import BasicComponent from './picture-basic.vue';
import EventComponent from './picture-event.vue';
import RevenueComponent from './picture-revenue.vue';
import { alas, status } from '@/alas';
import { defineComponent, ref, onMounted } from '@vue/composition-api';
export default defineComponent({
    props: ['farm', 'type', 'picture'],
    components: {
        'self-basic': BasicComponent,
        'self-event': EventComponent,
        'self-revenue': RevenueComponent
    },
    setup(props) {
        // ================
        //
        // refs
        //
        let tab = ref(0);
        let types = ref(status.fetch('types'));
        let typeModel = ref(alas.make('crop', 'type'));
        // ================
        //
        // mounted
        //
        onMounted(() => {
            types.value.o.fetch.seek().then(() => {
                typeModel.value = types.value.fetch(props.type);
            });
        });
        // ================
        //
        // done
        //
        return {
            tab,
            types,
            typeModel
        };
    }
});
